export const state = {
    empresa: {},
    empresas: [],
    modalExcluirEmpresa: false,
    modalCadastrarEmpresa: false,
}

export default {}